import { ROUTE_COMERCIAL } from './../constants/constant.model';
import { StorageService } from './storage.service';
import { IRecursos } from './../models/irecursos';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecursosService {

  recursosCotizacion: BehaviorSubject<IRecursos> = new BehaviorSubject<IRecursos>(null);
  recursosOrdenPedido: BehaviorSubject<IRecursos> = new BehaviorSubject<IRecursos>(null);
  recursosGuiaRemision: BehaviorSubject<IRecursos> = new BehaviorSubject<IRecursos>(null);
  recursosBoleta: BehaviorSubject<IRecursos> = new BehaviorSubject<IRecursos>(null);
  recursosFactura: BehaviorSubject<IRecursos> = new BehaviorSubject<IRecursos>(null);

  constructor(
    private storageService: StorageService,
    private apiService: ApiService,
    private http: HttpClient) { }

  setRecursosCotizacion(recursosCotizacion: IRecursos) {
    this.storageService.setData('recursosCotizacion', JSON.stringify(recursosCotizacion));
    this.recursosCotizacion.next(recursosCotizacion);
  }

  setRecursosOrdenPedido(recursosOrdenPedido: IRecursos) {
    this.storageService.setData('recursosOrdenPedido', JSON.stringify(recursosOrdenPedido));
    this.recursosOrdenPedido.next(recursosOrdenPedido);
  }

  setRecursosGuiaRemision(recursosGuiaRemision: IRecursos) {
    this.storageService.setData('recursosGuiaRemision', JSON.stringify(recursosGuiaRemision));
    this.recursosGuiaRemision.next(recursosGuiaRemision);
  }

  setRecursosBoleta(recursosBoleta: IRecursos) {
    this.storageService.setData('recursosBoleta', JSON.stringify(recursosBoleta));
    this.recursosBoleta.next(recursosBoleta);
  }

  setRecursosFactura(recursosFactura: IRecursos) {
    this.storageService.setData('recursosFactura', JSON.stringify(recursosFactura));
    this.recursosFactura.next(recursosFactura);
  }

  getRecursos(tipoDocumento: number, codsuc: number, moting: boolean): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.recursos_url);
    return this.apiService.execGetQueryJson(`${tipoDocumento}` + "?codsuc=" + codsuc + "&moting=" + moting).pipe();
  }

  getRecursosCodmod(tipoDocumento: number, codsuc: number, moting: boolean,codmod: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.recursos_url);
    return this.apiService.execGetQueryJson(`${tipoDocumento}` + "?codsuc=" + codsuc + "&moting=" + moting+ "&codmod=" + codmod).pipe();
  }


  public recursosIC() {
    return this.http.get(environment.serviceUrl + "general/ic/recursos", { observe: 'response' },)
  }

  public recursosArticulo() {
    return this.http.get(environment.serviceUrl + "general/articulo/recursos", { observe: 'response' },)
  }

  public obtenerMonedas(soloActivos: Boolean) {
    return this.http.get(environment.serviceUrl + "tmoneda/buscar?activo=" + soloActivos, { observe: 'response' },)
  }

  public operacionesCajaTienda() {
    return this.http.get(environment.serviceUrl + "general/operaciones-caja-tienda", { observe: 'response' },)
  }




}